export default {
    data () {
        return { 
            revwstats:[],        
        } 
    },    
    methods: {
        getRevwStats() {
            this.$axios
                .post("ares/json/ares/task/customer_success/revw/getRevwStats.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getRevwStats"
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.revwstats = res.data.getRevwStats;
                    }
                });
        }
    }
}